module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrapper"
  }, [_c('div', {
    staticClass: "top-menu-icon",
    on: {
      "click": function($event) {
        _vm.changeShowMode()
      },
      "mouseover": function($event) {
        _vm.leaving = false
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.showMode == true ? 'top-menu-panel' : 'hidden-menu'],
    on: {
      "mouseover": function($event) {
        _vm.leaving = false
      },
      "mouseleave": function($event) {
        _vm.tryToLeave()
      }
    }
  }, [(_vm.activeUser != null) ? _c('div', {
    staticClass: "top-menu-user top-menu-link",
    on: {
      "click": function($event) {
        _vm.$router.push('/profile')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-left": "50px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "top-menu-user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.activeUser.body.avatar) + ')'
    })
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "text-align": "center",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.activeUser.name))])]) : _c('div', {
    staticClass: "top-menu-user",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_vm._v("ВХОД В АККАУНТ")]), _vm._v(" "), _c('div', {
    staticClass: "top-menu-line",
    staticStyle: {
      "margin": "20px 0 10px 0"
    }
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.activeUser == null) ? _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false;
        _vm.loginOnClick()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-circle top-menu-item-icon",
    staticStyle: {
      "padding-right": "1px"
    }
  }), _vm._v("\n      Вход\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fire top-menu-item-icon"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Лента событий")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false;
        _vm.copyInvitationLinkToClipboardOnClick()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-share-alt top-menu-item-icon"
  }), _vm._v("\n      Пригласить друга\n    ")]), _vm._v(" "), (_vm.activeUser != null) ? _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle top-menu-item-icon"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/event-edit"
    }
  }, [_vm._v("Создать событие")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker-alt top-menu-item-icon"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/places"
    }
  }, [_vm._v("Места в городе")])], 1), _vm._v(" "), (_vm.activeUser != null) ? _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user top-menu-item-icon"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("Профиль")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeUser != null) ? _c('div', {
    staticClass: "top-menu-item",
    on: {
      "click": function($event) {
        _vm.showMode = false;
        _vm.logoutOnClick()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-power-off top-menu-item-icon",
    staticStyle: {
      "font-size": "18px",
      "padding-right": "1px"
    }
  }), _vm._v("\n      Выход\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-menu-line",
    staticStyle: {
      "margin": "5px 0 0 0"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "top-menu-text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      © ВСЕЗДЕСЬ, 2022\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.appSettings.appVer) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff61d5e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMenu.vue
// module id = 358
// module chunks = 0